<template>
  <section>
    <modal :title="title" :show="showModal" @close="closeModal()">
      <div class="content" slot="content">
        <form>
          <div
            class="upload-area"
            @click="!loaderFile && $refs.fileInput.click()"
          >
            <label
              v-if="!loaderFile && !successFile"
              class="placeholder"
              style="cursor:pointer"
            >
              <i class="fas fa-cloud-upload-alt"></i>
              <span>Enviar arquivo CSV</span>
            </label>
            <label
              v-if="successFile"
              class="placeholder"
              style="cursor:pointer"
            >
              <i class="fas fa-cloud-upload-alt"></i>
              <p>
                Seu arquivo CSV já está em nossos servidores clique no botão importar para começar o processo.
              </p>
            </label>
            <input
              ref="fileInput"
              type="file"
              @change="uploadFile"
              style="display: none"
            />
            <div v-if="loaderFile">
              <p>Enviando arquivo...</p>
            </div>
          </div>

          <article class="center">
            <span class="info">
              <i class="fas fa-info-circle"></i>Baixar <a :href="urlModelCsv">modelo CSV</a>
            </span>
          </article>
        </form>
      </div>
      <div class="action" slot="action">
        <div class="flex center">
          <button @click="closeModal()" class="button secondary medium">
            Voltar
          </button>
          <button
            type="submit"
            @click="acceptModal()"
            class="button primary medium"
            :class="{ unusual: unusual == 'accept' }"
          >
            {{ isEdit ? "Editar" : "Importar" }}
          </button>
        </div>
      </div>
    </modal>
  </section>
</template>

<script>

import { Upload } from "@/services/upload";



import Modal from "@/components/modal/Modal";

export default {
  name: "modal-new-import",
  props: {
    titleName: {
      required: false,
      default: "Importar Contatos",
    },
    show: {
      required: true,
      default: false,
    },
    unusual: {
      required: false,
      default: "false",
    },
  },
  components: {
    Modal,
  },
  data() {
    return {
      importType: "csv",
      showDeleteModal: false,
      selectModalDelete: null,
      showModal: false,
      seenGuide: {},
      title: "Importar novo arquivo",
      file: null,
      loaderFile: false,
      import: {}
    };
  },
  watch: {
    show(value) {
      this.showModal = value;
    },
  },
  updated() {
    if (this.isEdit) {
      this.title = "Editar Importação";
    }
  },
  mounted() {
    if (this.isEdit) {
      this.title = "Editar Importação";
    }
  },
  computed: {
    isEdit() {
      return this.import && this.import.id;
    },
    urlModelCsv() {
      return ''
    }
  },
  methods: {
    uploadFile() {
      this.file = this.$refs.fileInput.files[0];
      this.loaderFile = true;
      Upload(this.content, this.file, "csv")
        .then((result) => {
          this.successFile = true;
          this.import = result
        })
        .finally(() => {
          this.loaderFile = false;
        });
    },
    acceptModal() {
      this.showModal = false;
      this.$emit("accept", this.import);
    },
    closeModal() {
      this.showModal = false;
      this.$emit("close", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.action {
  margin-top: 30px;
  .button {
    margin-left: 10px !important;
  }
}

textarea {
  border-radius: 5px;
  border: 1px solid #3333;
  padding: 15px;
  max-width: 500px;
  min-width: 500px;
  min-height: 150px;
  max-height: 150px;
}

ul {
  list-style: none;
  max-height: 200px;
  overflow-y: scroll;
  li {
    padding: 4px 8px;
    border-bottom: 1px solid #ccc;
    .tag {
      background: #c2c2c2;
      padding: 4px 6px;
      border-radius: 5px;
      font-size: 11px;
      font-weight: 800;
      margin-left: 8px;
    }
    .button {
      margin-left: 4px;
      padding: 4px 6px;
    }
  }
}
</style>
